import React from 'react';
import './HeroSection.css';

/// ヒーローセクション - マール・アストレアの紹介セクション
const HeroSection: React.FC = () => {
  /// スムーズスクロール関数（ヘッダーの高さを考慮）
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 70; // ヘッダーの高さ + 余白
      const elementPosition = element.offsetTop - headerHeight;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };
  return (
    <section className="hero-section" id="home">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-image">
            <img 
              src="/assets/images/icon/marle_stand.png" 
              alt="マール・アストレア" 
              className="profile-image"
              onError={(e) => {
                // メイン画像が見つからない場合のフォールバック
                e.currentTarget.src = '/assets/images/icon/marle_stand.png';
              }}
            />
            <div className="image-glow"></div>
          </div>
          
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="title-greeting">ようこそ</span>
              <span className="title-name">マール・アストレア</span>
              <span className="title-description">非公式ファンサイトへ</span>
            </h1>
            
            <p className="hero-description">
              見習い神官として皆様に癒しをお届けしていたマール・アストレアの
              <br />
              大切な思い出と配信アーカイブを永久保存するサイトです。
              <br />
              ここではマールちゃんとの素敵な時間を振り返ることができます。
            </p>
            
            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">104</span>
                <span className="stat-label">総配信数</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">2023.8 - 2024.5</span>
                <span className="stat-label">活動期間</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">∞</span>
                <span className="stat-label">思い出</span>
              </div>
            </div>
            
            <div className="hero-actions">
              <button className="btn-primary" onClick={() => scrollToSection('videos')}>
                動画を見る
              </button>
              <button className="btn-secondary" onClick={() => scrollToSection('profile')}>
                プロフィール
              </button>
            </div>
          </div>
        </div>
        
        <div className="floating-elements">
          <div className="floating-star star-1">✨</div>
          <div className="floating-star star-2">⭐</div>
          <div className="floating-star star-3">💫</div>
          <div className="floating-heart heart-1">💕</div>
          <div className="floating-heart heart-2">💖</div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 